import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["src"]

import { computed } from "vue"
import { useRoute } from "vue-router"
import { authStore } from "@/store/login"
import { loadSession } from "@/composables/useSession"


export default /*@__PURE__*/_defineComponent({
  __name: 'AngularEmbedPage',
  setup(__props) {

const route = useRoute()
const auth = authStore()

const ANGULAR_URL = process.env.VUE_APP_ANGULAR_URL || ""

const iframeSrc = computed(() => {
	const angularPath = String((route.meta as Record<string, unknown>).angularPath ?? "")
	console.log('angularPath=', angularPath)
	console.log('process.env.VUE_APP_ANGULAR_URL=', process.env.VUE_APP_ANGULAR_URL)
	if (!angularPath || !ANGULAR_URL) return ""

	const session = loadSession()
	const token = auth.jwtToken ?? session?.jwtToken ?? ""
	const sessionKey = auth.sessionKey ?? session?.sessionKey ?? ""
	const userId = auth.currentUserId ?? session?.id ?? ""

	const params = new URLSearchParams({
		token: String(token),
		sessionKey: String(sessionKey),
		userId: String(userId),
		embedded: "true",
	})
	return `${ANGULAR_URL}/${angularPath}?${params.toString()}`
})

return (_ctx: any,_cache: any) => {
  return (iframeSrc.value)
    ? (_openBlock(), _createElementBlock("iframe", {
        key: 0,
        class: "angular-frame",
        src: iframeSrc.value,
        title: "Angular page"
      }, null, 8, _hoisted_1))
    : _createCommentVNode("", true)
}
}

})